module.exports = __webpack_public_path__ + "static/MC_steps_reemplazo_FISICA_2_B-68b066d67e5a8694af6f8f85fab53874.gif";